import { render, staticRenderFns } from "./ElderlyIcon.vue?vue&type=template&id=5ec4cfbb&scoped=true&"
import script from "./ElderlyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ElderlyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec4cfbb",
  null
  
)

export default component.exports